import React, { useState, useMemo } from 'react';
import TopNavbar from '../../../home/TopNavbar';

// Data parsed cleanly from your JEE Main math weightage table
const rawData = [
  // Class XIth
  { class: 'Class XIth Mathematics', sno: 1, chapter: 'Basic Mathematics and Logarithm', weightage: 0.59 },
  { class: 'Class XIth Mathematics', sno: 2, chapter: 'Sets', weightage: 1.00 },
  { class: 'Class XIth Mathematics', sno: 3, chapter: 'Trigonometric Ratios and Identities', weightage: 1.02 },
  { class: 'Class XIth Mathematics', sno: 4, chapter: 'Trigonometric Equations', weightage: 1.35 },
  { class: 'Class XIth Mathematics', sno: 5, chapter: 'Quadratic Equations', weightage: 3.30 },
  { class: 'Class XIth Mathematics', sno: 6, chapter: 'Complex Number', weightage: 4.75 },
  { class: 'Class XIth Mathematics', sno: 7, chapter: 'Sequences and Series', weightage: 5.74 },
  { class: 'Class XIth Mathematics', sno: 8, chapter: 'Binomial Theorem', weightage: 5.05 },
  { class: 'Class XIth Mathematics', sno: 9, chapter: 'Permutations and Combinations', weightage: 3.60 },
  { class: 'Class XIth Mathematics', sno: 10, chapter: 'Straight Lines', weightage: 2.71 },
  { class: 'Class XIth Mathematics', sno: 11, chapter: 'Circles', weightage: 3.24 },
  { class: 'Class XIth Mathematics', sno: 12, chapter: 'Conic Sections: Parabola', weightage: 2.44 },
  { class: 'Class XIth Mathematics', sno: 13, chapter: 'Conic Sections: Ellipse', weightage: 2.11 },
  { class: 'Class XIth Mathematics', sno: 14, chapter: 'Conic Sections: Hyperbola', weightage: 1.65 },
  { class: 'Class XIth Mathematics', sno: 15, chapter: 'Statistics', weightage: 3.00 },
  { class: 'Class XIth Mathematics', sno: 16, chapter: 'Properties of a Triangle', weightage: 0.36 },

  // Class XIIth
  { class: 'Class XIIth Mathematics', sno: 1, chapter: 'Determinants', weightage: 4.00 },
  { class: 'Class XIIth Mathematics', sno: 2, chapter: 'Matrices', weightage: 3.46 },
  { class: 'Class XIIth Mathematics', sno: 3, chapter: 'Relations and Functions', weightage: 1.25 },
  { class: 'Class XIIth Mathematics', sno: 4, chapter: 'Inverse Trigonometric Functions', weightage: 1.59 },
  { class: 'Class XIIth Mathematics', sno: 5, chapter: 'Limit, Continuity, and Differentiability', weightage: 5.50 },
  { class: 'Class XIIth Mathematics', sno: 6, chapter: 'Methods of Differentiation', weightage: 1.24 },
  { class: 'Class XIIth Mathematics', sno: 7, chapter: 'Applications of Derivatives', weightage: 4.75 },
  { class: 'Class XIIth Mathematics', sno: 8, chapter: 'Indefinite Integration', weightage: 1.65 },
  { class: 'Class XIIth Mathematics', sno: 9, chapter: 'Definite Integration', weightage: 5.08 },
  { class: 'Class XIIth Mathematics', sno: 10, chapter: 'Application of Integrals', weightage: 2.97 },
  { class: 'Class XIIth Mathematics', sno: 11, chapter: 'Differential Equations', weightage: 4.16 },
  { class: 'Class XIIth Mathematics', sno: 12, chapter: 'Vector Algebra', weightage: 4.69 },
  { class: 'Class XIIth Mathematics', sno: 13, chapter: 'Three-Dimensional Geometry', weightage: 7.35 },
  { class: 'Class XIIth Mathematics', sno: 15, chapter: 'Probability', weightage: 3.09 },
];

export default function ChapterWiseWeightageMathTopics() {
  const [selectedClass, setSelectedClass] = useState('ALL');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('weightage-desc');

  const maxWeightage = useMemo(() => Math.max(...rawData.map((i) => i.weightage)), []);

  const filteredData = useMemo(() => {
    return rawData
      .filter((item) => {
        const matchesClass = selectedClass === 'ALL' || item.class === selectedClass;
        const matchesSearch = item.chapter.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesClass && matchesSearch;
      })
      .sort((a, b) => {
        if (sortBy === 'weightage-desc') return b.weightage - a.weightage;
        if (sortBy === 'weightage-asc') return a.weightage - b.weightage;
        if (sortBy === 'alphabetical') return a.chapter.localeCompare(b.chapter);
        return 0;
      });
  }, [selectedClass, searchTerm, sortBy]);

  const stats = useMemo(() => {
    const class11Total = rawData
      .filter((d) => d.class === 'Class XIth Mathematics')
      .reduce((acc, curr) => acc + curr.weightage, 0);
    const class12Total = rawData
      .filter((d) => d.class === 'Class XIIth Mathematics')
      .reduce((acc, curr) => acc + curr.weightage, 0);
    const highWeightCount = rawData.filter((d) => d.weightage >= 4.0).length;
    const topTopic = [...rawData].sort((a, b) => b.weightage - a.weightage)[0];
    return { class11Total, class12Total, highWeightCount, topTopic };
  }, []);

  return (
    <>
      <style>{`
        .jeew-container {
          max-width: 1000px;
          margin: 0 auto;
          padding: 24px 16px;
          font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
          color: #1f2937;
          background-color: #f9fafb;
          min-height: 100vh;
          margin-top: 50px;
          margin-bottom: 50px;
        }
        .jeew-header {
          text-align: center;
          margin-bottom: 24px;
        }
        .jeew-header h1 {
          font-size: 1.85rem;
          font-weight: 800;
          color: #111827;
          margin: 0 0 8px 0;
        }
        .jeew-header p {
          color: #4b5563;
          font-size: 0.95rem;
          line-height: 1.5;
          max-width: 750px;
          margin: 0 auto;
        }
        .jeew-stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
          gap: 16px;
          margin-bottom: 24px;
        }
        .jeew-stat-card {
          background: #ffffff;
          padding: 16px;
          border-radius: 12px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.08);
          border: 1px solid #e5e7eb;
        }
        .jeew-stat-label {
          font-size: 0.75rem;
          text-transform: uppercase;
          letter-spacing: 0.05em;
          color: #6b7280;
          font-weight: 600;
          margin-bottom: 4px;
        }
        .jeew-stat-value {
          font-size: 1.35rem;
          font-weight: 700;
          color: #2563eb;
        }
        .jeew-stat-sub {
          font-size: 0.75rem;
          color: #9ca3af;
          margin-top: 2px;
        }
        .jeew-controls {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          justify-content: space-between;
          align-items: center;
          background: #ffffff;
          padding: 16px;
          border-radius: 12px;
          border: 1px solid #e5e7eb;
          margin-bottom: 20px;
        }
        .jeew-tabs {
          display: flex;
          gap: 6px;
        }
        .jeew-tab-btn {
          padding: 8px 16px;
          border-radius: 8px;
          font-size: 0.85rem;
          font-weight: 600;
          border: 1px solid #d1d5db;
          background: #f3f4f6;
          color: #374151;
          cursor: pointer;
          transition: all 0.2s;
        }
        .jeew-tab-btn.active {
          background: #2563eb;
          color: #ffffff;
          border-color: #2563eb;
        }
        .jeew-filter-group {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }
        .jeew-input, .jeew-select {
          padding: 8px 12px;
          border-radius: 8px;
          border: 1px solid #d1d5db;
          font-size: 0.85rem;
          background: #fff;
          color: #1f2937;
        }
        .jeew-table-wrapper {
          background: #ffffff;
          border-radius: 12px;
          border: 1px solid #e5e7eb;
          overflow-x: auto;
          box-shadow: 0 1px 3px rgba(0,0,0,0.06);
        }
        .jeew-table {
          width: 100%;
          border-collapse: collapse;
          text-align: left;
          font-size: 0.9rem;
        }
        .jeew-table th, .jeew-table td {
          padding: 12px 16px;
          border-bottom: 1px solid #f3f4f6;
        }
        .jeew-table th {
          background: #f8fafc;
          font-weight: 600;
          color: #374151;
          font-size: 0.8rem;
          text-transform: uppercase;
          letter-spacing: 0.03em;
        }
        .jeew-bar-container {
          background: #e5e7eb;
          height: 8px;
          border-radius: 4px;
          width: 120px;
          overflow: hidden;
        }
        .jeew-bar-fill {
          height: 100%;
          background: #2563eb;
          border-radius: 4px;
        }
        .jeew-badge {
          display: inline-block;
          padding: 2px 8px;
          border-radius: 999px;
          font-size: 0.75rem;
          font-weight: 600;
        }
        .jeew-badge-high {
          background: #dbeafe;
          color: #1e40af;
        }
        .jeew-badge-class {
          background: #f1f5f9;
          color: #475569;
          font-size: 0.7rem;
        }
        .jeew-empty {
          text-align: center;
          padding: 32px;
          color: #6b7280;
        }
      `}</style>

      <div className="jeew-container">

      <TopNavbar name="Maths Weightage" ></TopNavbar>

        <header className="jeew-header">
          <h3 style={{color: "green"}}>JEE Main Past 5 Years Chapter-wise Weightage for Maths</h3>
          <p>
            The table below provides the chapter-wise weightage of Mathematics in the past five years of the JEE Main exam. It helps students understand the trend and frequency of questions from each topic.
          </p>
        </header>

        <div className="jeew-stats-grid">
          <div className="jeew-stat-card">
            <div className="jeew-stat-label">Top Scoring Topic</div>
            <div className="jeew-stat-value">{stats.topTopic?.weightage}%</div>
            <div className="jeew-stat-sub">{stats.topTopic?.chapter}</div>
          </div>
          <div className="jeew-stat-card">
            <div className="jeew-stat-label">High-Impact Topics (&gt;4%)</div>
            <div className="jeew-stat-value">{stats.highWeightCount} Chapters</div>
            <div className="jeew-stat-sub">High priority scoring zones</div>
          </div>
          <div className="jeew-stat-card">
            <div className="jeew-stat-label">Class XIth Weight Sum</div>
            <div className="jeew-stat-value">{stats.class11Total.toFixed(2)}%</div>
            <div className="jeew-stat-sub">16 total chapters tracked</div>
          </div>
          <div className="jeew-stat-card">
            <div className="jeew-stat-label">Class XIIth Weight Sum</div>
            <div className="jeew-stat-value">{stats.class12Total.toFixed(2)}%</div>
            <div className="jeew-stat-sub">14 total chapters tracked</div>
          </div>
        </div>

        <div className="jeew-controls">
          <div className="jeew-tabs">
            <button
              className={`jeew-tab-btn ${selectedClass === 'ALL' ? 'active' : ''}`}
              onClick={() => setSelectedClass('ALL')}
            >
              All Classes
            </button>
            <button
              className={`jeew-tab-btn ${selectedClass === 'Class XIth Mathematics' ? 'active' : ''}`}
              onClick={() => setSelectedClass('Class XIth Mathematics')}
            >
              Class XIth
            </button>
            <button
              className={`jeew-tab-btn ${selectedClass === 'Class XIIth Mathematics' ? 'active' : ''}`}
              onClick={() => setSelectedClass('Class XIIth Mathematics')}
            >
              Class XIIth
            </button>
          </div>

          <div className="jeew-filter-group">
            <input
              type="text"
              placeholder="Search chapters..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="jeew-input"
            />
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="jeew-select"
            >
              <option value="weightage-desc">Weightage: High to Low</option>
              <option value="weightage-asc">Weightage: Low to High</option>
              <option value="alphabetical">Alphabetical (A-Z)</option>
            </select>
          </div>
        </div>

        <div className="jeew-table-wrapper">
          <table className="jeew-table">
            <thead>
              <tr>
                <th>Class</th>
                <th>S. No.</th>
                <th>Chapter Name</th>
                <th>Weightage Share</th>
                <th>Relative Weight</th>
              </tr>
            </thead>
            <tbody>
              {filteredData.length > 0 ? (
                filteredData.map((row, idx) => {
                  const percentWidth = Math.min(100, (row.weightage / maxWeightage) * 100);
                  return (
                    <tr key={`${row.class}-${row.sno}-${idx}`}>
                      <td>
                        <span className="jeew-badge jeew-badge-class">
                          {row.class.replace(' Mathematics', '')}
                        </span>
                      </td>
                      <td>{row.sno}</td>
                      <td><strong>{row.chapter}</strong></td>
                      <td>
                        <span
                          className={`jeew-badge ${
                            row.weightage >= 4.0 ? 'jeew-badge-high' : ''
                          }`}
                        >
                          {row.weightage.toFixed(2)}%
                        </span>
                      </td>
                      <td>
                        <div className="jeew-bar-container">
                          <div
                            className="jeew-bar-fill"
                            style={{ width: `${percentWidth}%` }}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="5" className="jeew-empty">
                    No matching chapters found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}